import React, { useEffect } from "react";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useCommands } from "../../commands/useCommands";
import { CommandsDirectory } from "../../commands/lib";

export const AddAccountsRoute: React.FC = () => {
    const navigate = useStateAwareNavigate();
    const { open } = useCommands();

    useEffect(() => {
        open(CommandsDirectory.ACCOUNTS);
        navigate("/");
    }, [navigate, open]);

    return null;
};
